export const INITIAL_TRACE_KEY = "appinsights:initial-trace";
